import React from 'react'
import { LightButton } from 'styles/GlobalStyle'
import { EmailSignatureStyles } from './Style'

const EmailSignature = () => {

    return (
        <EmailSignatureStyles>
            <a href="https://go-read.ai/" target="_blank">
                <LightButton size='small'>כניסה למערכת</LightButton>
            </a>
            <a href="https://123goread.ai/" target="_blank">
                <LightButton size='small'>לאתר שלנו</LightButton>
            </a>
            <a href="https://d3v34xxa99dhvk.cloudfront.net/goreadvideov2.mp4" target="_blank">
                <LightButton size='small'>סרטון הסברה</LightButton>
            </a>
        </EmailSignatureStyles>
    )
}

export default EmailSignature